const SETTINGS_PATHS = {
  ROOT: '/settings',
  APPOINTMENTS: '/settings/appointments',
  FORMS: '/settings/forms',
  ORGANIZATION: '/settings/organization',
  PAYERS: '/settings/payers',
  TAGS: '/settings/tags',
  USERS: '/settings/users',
  VISIT_NOTES: '/settings/visit-notes',
  PCC: '/settings/pcc',
} as const;

export default SETTINGS_PATHS;
